import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-pass2",
  "use": "icon-pass2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pass2\"><path d=\"M192 128V64H64v896h128v-64h-64V672h64v-64h-64V384h64v-64h-64V128h64zM608 320a286.9 286.9 0 1 1-112.08 22.61A286.13 286.13 0 0 1 608 320m0-64c-194.4 0-352 157.6-352 352s157.6 352 352 352 352-157.6 352-352-157.6-352-352-352z\" p-id=\"1540\" /><path d=\"M781.45 469.93L576 670.21 466.55 565.88 416 614.77l107.86 104.34L576 768l48.95-48.89L832 518.82l-50.55-48.89z\" p-id=\"1541\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-pass2.svg
// module id = 2nM9
// module chunks = 175